import { render, staticRenderFns } from "./OptionalTasks.vue?vue&type=template&id=3ba3ef9e&scoped=true"
import script from "./OptionalTasks.vue?vue&type=script&lang=js"
export * from "./OptionalTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba3ef9e",
  null
  
)

export default component.exports